import 'normalize.css';
import svg4everybody from 'svg4everybody';
import '../assets/styles/vendors/font-awesome.min.css';
import '../assets/styles/vendors/jgallery.min.css';
import '../assets/styles/index.main.scss';
import callToTelList from './components/callToListPhones.js';
import resizeZabor from './components/resize_zabor.js';
import './components/hamburger_menu.js';
import scrollSection from './components/scroll.js';
svg4everybody();
const $ = require('jquery');
import './components/tinycolor-0.9.16.min.js';
import './components/jgallery.min.js';
import './components/touchswipe.min.js';
import openModalForm from './components/modalform_open.js';
import formPopupHandler from './components/modalform.js';
import formGazonHandler from './components/form_gazon.js';
import  formProjectHandler from './components/zakaz_project.js';

const init = () => {
  callToTelList.handler();
  resizeZabor.handler();
  $.fatNav();
  scrollSection.init();
  const startGalleryBut = $('.gallery__open-link');
   startGalleryBut.on('click', galleryStart);
   openModalForm();
   formPopupHandler();
   formGazonHandler();
   formProjectHandler();
};

window.onload = init;

const galleryStart = (e) => {
  e.preventDefault();
  const openBlock = $('.gallery__open');
  const gallery = $('#gallery');
  $(openBlock).addClass('fadeout');
    $(gallery).jGallery({ 
      mode: 'full-screen',
      canChangeMode: false,
      backgroundColor: '#edffc9',
      textColor: 'rgb(57, 57, 57)',
      canClose: true,
      thumbnails: true,
      hideThumbnailsOnInit: false,
      thumbnailsFullScreen: true,
      canZoom: true,
      preloadAll: false,
      slideshow: true,
      swipeEvents: true,
      thumbHeightOnFullScreen: 100,
      thumbnailsHideOnMobile: false,
      thumbType: 'image',
      thumbnailsPosition: 'bottom', // [ top | bottom | left | right 
      tooltipClose: 'Закрыть',
      tooltipSlideshow: 'Slideshow',
      autostartAtImage: 1,
      thumbWidthOnFullScreen: 100, //px
      thumbHeightOnFullScreen: 100, //px
      canMinimalizeThumbnails: true,
      disabledOnIE8AndOlder: true,
      transitionDuration: '0.7s',
      closeGallery: function() {
        $(gallery).css('display', 'none');
        $(openBlock).removeClass('fadeout');
      }
  });
}


// WEBPACK FOOTER //
// ./app/index.js